import { css } from "@emotion/react";

export const ctaSection = css({
  width: "100%",
  padding: "40px 20px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#f5f5f5",
  backgroundImage: "url('/images/cta-bg-texture.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  boxSizing: "border-box",
});

export const ctaContent = css({
  maxWidth: 800,
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const ctaButton = css({
  marginTop: 24,
  padding: "10px 24px",
  textTransform: "uppercase",
});

export const featuresGrid = css({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 16,
  maxWidth: 800,
  margin: "24px auto",
  "@media (max-width: 600px)": {
    gridTemplateColumns: "1fr",
  },
});

export const featureCard = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: 16,
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  borderRadius: 8,
  border: "1px solid rgba(255, 255, 255, 0.2)",
  backdropFilter: "blur(10px)",
});

export const featureIcon = css({
  fontSize: 32,
  marginBottom: 8,
});

export const featureTitle = css({
  fontWeight: 500,
});

export const featureDescription = css({
  opacity: 0.8,
  marginTop: 4,
});
